module.exports = __webpack_public_path__ + "img/2.3640f722.jpg";